/* eslint-disable @typescript-eslint/camelcase */

export const CUSTOM_DIMENSIONS = {
  logged_in: 'dimension1',
  music_active: 'dimension2',
  sfx_active: 'dimension3',
  engagement: 'dimension4',
  progress: 'dimension5',
};

export const CUSTOM_METRICS = {
  game_ready_timing: 'metric1',
  session_progress: 'metric2',
  total_progress: 'metric3',
  fails_on_hints_click: 'metric4',
};
